import _extends from "@babel/runtime/helpers/extends";
export default (function (baseStyles, _ref) {
  var isMulti = _ref.isMulti;
  return _extends({}, baseStyles, {
    marginLeft: isMulti && 8
  });
});